import { Form, Formik, FormikHelpers, FieldArray } from "formik";
import { Button } from "@material-ui/core";
import React from "react";
import * as Yup from 'yup';
import { createSubmitHandler } from "../../form/helpers/formSubmit";
import { AdpCompanySignInReportRequest, CompanyNoteReportRequest } from "../../../models/Report";
import { DateInput } from "../../form/inputs/DateInput";
import PickerInput from "../../form/inputs/PickerInput";

interface Props<T> {
    initialValues: T;
    validationSchema: any;
    onSubmit: (values: T, actions: FormikHelpers<T>) => void;
}

function SearchForm<T>({ initialValues, validationSchema, onSubmit }: Props<T>) {
    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ resetForm, handleSubmit }) => {
                return (
                    <Form onSubmit={handleSubmit}>
                        <DateInput name='dateFrom' label='Date From' />
                        <DateInput name='dateTo' label='Date To' />
                        <PickerInput name='source' label={'Source'} options={[{ id: 'upnetic', label: 'Upnetic' }, { id: 'bizpro', label: 'BizPro' }]} />
                        <Button type='submit' variant='contained' color='primary' style={{ margin: '14px' }}>Search</Button>
                        <Button type='submit' variant='contained' color='secondary' style={{ margin: '14px' }} onClick={() => { resetForm(); }}>Clear</Button>
                    </Form>
                );
            }}
        </Formik>
    )
}

export function AdpCompanySignInSearchForm(props: { initValues: AdpCompanySignInReportRequest, onSearch: (results: AdpCompanySignInReportRequest) => void }) {
    const { initValues, onSearch } = props;

    const validationSchema = Yup.object().shape({
        source: Yup.string()
            .required("Must select a source"),

        dateFrom: Yup.date()
            .required("Must enter from date"),

        dateTo: Yup.date()
            .nullable()
            .default(null)
            .when("dateFrom", (dateFrom: Date, Yup: any) => dateFrom && Yup.min(dateFrom, "Date To cannot be before date from"))
    });

    const onSubmit =
        createSubmitHandler(
            (body: AdpCompanySignInReportRequest) => Promise.resolve(body),
            onSearch,
            console.error
        );

    return (
        <SearchForm initialValues={initValues} validationSchema={validationSchema} onSubmit={onSubmit} />
    );
}